import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';

const LeftBanner = () => {
    const [text] = useTypewriter({
      words: [
        "Software Engineer.",
        "AI, ML & Data Science Enthusiast.",
        "Filmmaker, Writer, Creative Producer & Actor.",
        "Educator & Mentor.",
      ],
      loop: true,
      typeSpeed: 25,
      deleteSpeed: 10,
      delaySpeed: 2500,
    });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">WELCOME TO MY WORLD</h4>
        <h1 className="text-4xl font-bold text-white">
          <span className="text-5xl text-designColor capitalize">Shamim Rahman Sam</span>
        </h1>
        <h2 className="text-3xl font-bold text-white">
          <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-lg font-bodyFont leading-8 tracking-wide">
          I build <span className="text-designColor">Digital Products</span>,
          explore <span className="text-designColor">Intelligent Systems</span>,
          create <span className="text-designColor">Visual Stories</span>,
          and help people learn.
        </p>

        <p className="text-base font-bodyFont leading-7 tracking-wide">
          A multidisciplinary professional working across{" "}
          <span className="text-designColor">
            Technology, AI & Data, Film & Media, and Education
          </span>
          {" "}— with professional experience in{" "}
          <span className="text-designColor">Software Engineering</span>{" "}
          since <span className="text-designColor">2024</span>, creating and
          contributing to film, television and digital productions for{" "}
          <span className="text-designColor">8+ Years</span> since{" "}
          <span className="text-designColor">2015</span>, and teaching across
          Programming, IT, STEM, IELTS and academic subjects for{" "}
          <span className="text-designColor">13+ Years</span> since{" "}
          <span className="text-designColor">2012</span>.
        </p>
      </div>
     {/* Media */}
     <Media />
    </div>
  );
}

export default LeftBanner;